import React from "react";

import styled from "styled-components";

import { Dropdown } from "react-bootstrap";

import { NARRATIVE_MEDIA_TYPES } from "narratives/constants";

import Link from "next/link";

import {
  BORDER_RADIUS,
  BORDER_RADIUS_SMALL,
  COLORS,
  DEFAULT_BOX_SHADOW,
} from "utils/styles";

const NarrativeNavContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NarrativeNavButtonDropdown = styled.div`
  background-color: white;
  padding: 1rem;
  ${BORDER_RADIUS}
  ${DEFAULT_BOX_SHADOW}
`;

const NarrativeNavFilterLink = styled.a`
  cursor: pointer;
  display: block;
  font-family: mabry-regular;
  display: flex;
  align-items: center;
  justify-content: space-between;

  white-space: nowrap;
  font-family: ${({ active }) => (active ? "mabry-medium" : "mabry-regular")};

  &:after {
    margin-left: 1rem;
    display: block;
    float: right;
    content: " ";
    background-color: ${({ active }) => (active ? COLORS.BLACK : COLORS.GRAY)};
    border: 3px solid ${COLORS.GRAY};
    height: 1rem;
    width: 1rem;
    ${BORDER_RADIUS_SMALL}
  }
`;
const NarrativeNavButton = styled.a`
  display: inline-block;
  ${BORDER_RADIUS_SMALL}
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  position: relative;
  &:after {
    display: none;
  }

  ${({ inactive }) => (inactive ? "opacity: 0.5;" : "")}
`;

const NarrativeNavGroup = styled.div`
  display: flex;

  .dropdown {
    display: flex;
  }

  ${NarrativeNavButton} {
    margin-left: 1rem;
  }
`;

const NarrativeNavButtonIcon = styled.i.attrs({
  className: "material-icons-round md-dark md-18 mr-1",
})``;
const NarrativeNavButtonText = styled.span``;

const dataWindowSizeOptions = [
  { days: 365, label: "1 Year" },
  { days: 365 / 2, label: "6 Months" },
  { days: 365 / 4, label: "3 Months" },
  { days: 365 / 12, label: "1 Month" },
];

export default function NarrativeNav({
  containerBase,
  activeMedia,
  activeNarrative,
  handleMediaChange,
  dataWindowSize,
  handleDataWindowSizeChange,
}) {
  const selectedDataWindowSizeOption = dataWindowSizeOptions.find(
    ({ days }) => days === dataWindowSize
  );

  return (
    <NarrativeNavContainer as={containerBase}>
      <NarrativeNavGroup>
        {
          // TODO: Add button to collapse info panel
        }
      </NarrativeNavGroup>
      <NarrativeNavGroup>
        <Dropdown>
          <Dropdown.Toggle as={NarrativeNavButton}>
            <NarrativeNavButtonIcon>date_range</NarrativeNavButtonIcon>
            <NarrativeNavButtonText>
              {selectedDataWindowSizeOption.label}
            </NarrativeNavButtonText>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <NarrativeNavButtonDropdown>
              {dataWindowSizeOptions.map(({ days, label }) => (
                <NarrativeNavFilterLink
                  active={days === dataWindowSize}
                  key={days}
                  onClick={() => handleDataWindowSizeChange(days)}
                >
                  {label}
                </NarrativeNavFilterLink>
              ))}
            </NarrativeNavButtonDropdown>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle as={NarrativeNavButton}>
            <NarrativeNavButtonIcon>filter_list</NarrativeNavButtonIcon>
            <NarrativeNavButtonText>Filter</NarrativeNavButtonText>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <NarrativeNavButtonDropdown>
              <NarrativeNavFilterLink
                active={activeMedia === null}
                onClick={() => handleMediaChange(null)}
              >
                All
              </NarrativeNavFilterLink>
              {NARRATIVE_MEDIA_TYPES.map(({ slug, name }) => (
                <NarrativeNavFilterLink
                  active={activeMedia === slug}
                  key={slug}
                  onClick={() => handleMediaChange(slug)}
                >
                  {name}
                </NarrativeNavFilterLink>
              ))}
            </NarrativeNavButtonDropdown>
          </Dropdown.Menu>
        </Dropdown>
        <Link href="/narratives/compare">
          <NarrativeNavButton inactive={activeNarrative === null}>
            <NarrativeNavButtonIcon>tonality</NarrativeNavButtonIcon>
            <NarrativeNavButtonText>Compare</NarrativeNavButtonText>
          </NarrativeNavButton>
        </Link>
      </NarrativeNavGroup>
    </NarrativeNavContainer>
  );
}
